/* eslint-disable @next/next/no-img-element */
import { ARRAY_ELEMENT_ID } from '@cash-rewards/mparticlejs';
import {
  storeClickEventMapper,
  storeProductMapper,
} from '@cash-rewards/reactjs/client';

import ShopCarousel from '@/modules/core/components/shopCarousel/ShopCarousel';
import StoreAdCarouselCard from '@/modules/shop/components/storesCarousel/StoreAdCarouselCard';
import StoreCarouselCard from '@/modules/shop/components/storesCarousel/StoreCarouselCard';
import {
  Store,
  StoreAdModel,
  StoreModel,
} from '@/modules/shop/models/offerModels';

interface PopularStoresProps {
  stores: (StoreModel | StoreAdModel)[];
}

const isStoreAdModel = (store: Store): store is StoreAdModel => {
  return store.isAdvert === true;
};

const PopularStores = ({ stores, ...rest }: PopularStoresProps) => {
  return (
    <ShopCarousel
      title='Popular stores'
      navigationButtonTopCss='top-14'
      data-test-id='popular-stores-carousel'
      items={stores}
      productMappers={[storeProductMapper]}
      carouselType={ARRAY_ELEMENT_ID.store}
      clickEventMappers={[storeClickEventMapper]}
      {...rest}
    >
      {stores.map((store) => {
        if (isStoreAdModel(store)) {
          // Render StoreAdCarouselCard for StoreAdModel objects
          return (
            <StoreAdCarouselCard
              key={`ad-${store.id}`} // Ensure key is unique and prefixed for clarity
              store={store}
              data-test-id={`store-ad-card-box-${store.id}`}
              className='mr-cr-4 lg:mr-cr-8'
              impressionUrl={store.adImpressionUrl}
            />
          );
        }
        return (
          <StoreCarouselCard
            key={store.merchantId}
            store={store}
            data-test-id={`store-card-box-${store.merchantId}`}
            className='mr-cr-4 lg:mr-cr-8'
          ></StoreCarouselCard>
        );
      })}
    </ShopCarousel>
  );
};

export default PopularStores;
